import { Injectable } from '@angular/core';
import { Actions, createEffect, ofType } from '@ngrx/effects';
import { filter, map, switchMap, takeUntil } from 'rxjs';
import { TermSheetActions } from './term-sheet.actions';
import { TermSheetDocMetaService } from './term-sheet-doc-meta.service';

@Injectable()
export class TermSheetEffects {
  constructor(
    private actions$: Actions,
    private docMetaService: TermSheetDocMetaService
  ) {}

  subscribeDocMeta$ = createEffect(() =>
    this.actions$.pipe(
      ofType(TermSheetActions.subscribeDocMeta),
      switchMap(action =>
        this.docMetaService
          .subscribeDocMeta({
            mysid: action.mysid,
            q: action.q,
            s: 'model',
          })
          .pipe(
            takeUntil(
              this.actions$.pipe(
                ofType(TermSheetActions.unsubscribeDocMeta),
                filter(({ mysid }: any) => action.mysid === mysid)
              )
            ),
            map(({ op, res, sts, mysid }: any) => {
              if (op === 'query' || op === 'ins') {
                return res
                  ? TermSheetActions.getDocMetaSuccess({ mysid, res })
                  : TermSheetActions.getDocMetaFailure({ error: sts });
              }
              return { type: '[Term Sheet] Unknown doc meta operation' };
            })
          )
      )
    )
  );
}
